// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar_container__nsVY6 {
  background-color: #192949;
  width: var(--sidebar-width);
  position: fixed;
  z-index: 300;
  height: 100%;
  border-right: #404449 1px solid;
  color: #ffffff;
  -webkit-user-select: none;
          user-select: none;
  box-shadow: rgba(25, 41, 73, 0.3) -2px 0 50px 21px;
  font-family: Poppins, sans-serif;
  letter-spacing: 1px;
  font-weight: 500;
  line-height: 29px;
}

.sidebar_logoContainer__7\\+w3t {
  margin: 80px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar_sidebarDivider__Y\\+Kq2 {
  background-color: rgb(60, 80, 145);
  height: 2px;
  width: 80%;
  border-radius: 50%;
}

.sidebar_sidebarItem__Awi0D {
  color: #ffffff;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: 0.3s;
  -webkit-user-select: none;
          user-select: none;
  height: 46px;
  padding-left: 42px;
  position: relative;
  font-size: 13px;
}

.sidebar_sidebarItem__Awi0D:hover,
.sidebar_sidebarItemSelected__\\+N2kx {
  background-color: #293e70;
}

.sidebar_sidebarItemPill__1y8lT {
  background-color: #6a86c8;
  height: 46px;
  width: 6px;
  position: absolute;
  left: 0;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.sidebar_sidebarBottom__3Gbom {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.sidebar_profileImage__6Tdv4 {
  background-color: #ffffff;
  border-radius: 50%;
  height: 63px;
  width: 63px;
  /* margin-right: 13px; */
}

.sidebar_profile__ccsPW {
  padding: 32px 15px;
  display: flex; 
  gap: 10px;
  /* text-align: left; */
  cursor: pointer;
  align-items: center;
  justify-items: center;
}

.sidebar_settings__UAPW1 {
  display: flex;
  align-items: center;
  color: #c1c5df;
  cursor: pointer;
}

.sidebar_logout__B27YB {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 25px;
  z-index: 80;
  background-color: #656f84;
  border-radius: 14px;
  position: absolute;
  white-space: nowrap;
}

.sidebar_logoutTip__uaojO {
  height: 36px;
  width: 36px;
  position: absolute;
  background-color: #656f84;
  transform: rotateZ(45deg);
  left: -11px;
  border-radius: 6px;
  z-index: 50;
}

.sidebar_logoutContainer__l6-lH {
  font-family: Poppins, sans-serif;
  position: absolute;
  z-index: 100;
  border-radius: 14px;
  max-height: 64px;
  box-shadow: rgba(0, 0, 0, 25%) 0 5px 0 4px;
  right: 0%;
  top: 25%;
}
`, "",{"version":3,"sources":["webpack://./src/components/sidebar/sidebar.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,kDAAkD;EAClD,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,OAAO;EACP,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,SAAS;EACT,QAAQ;AACV","sourcesContent":[".container {\n  background-color: #192949;\n  width: var(--sidebar-width);\n  position: fixed;\n  z-index: 300;\n  height: 100%;\n  border-right: #404449 1px solid;\n  color: #ffffff;\n  user-select: none;\n  box-shadow: rgba(25, 41, 73, 0.3) -2px 0 50px 21px;\n  font-family: Poppins, sans-serif;\n  letter-spacing: 1px;\n  font-weight: 500;\n  line-height: 29px;\n}\n\n.logoContainer {\n  margin: 80px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sidebarDivider {\n  background-color: rgb(60, 80, 145);\n  height: 2px;\n  width: 80%;\n  border-radius: 50%;\n}\n\n.sidebarItem {\n  color: #ffffff;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  transition: 0.3s;\n  user-select: none;\n  height: 46px;\n  padding-left: 42px;\n  position: relative;\n  font-size: 13px;\n}\n\n.sidebarItem:hover,\n.sidebarItemSelected {\n  background-color: #293e70;\n}\n\n.sidebarItemPill {\n  background-color: #6a86c8;\n  height: 46px;\n  width: 6px;\n  position: absolute;\n  left: 0;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n}\n\n.sidebarBottom {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.profileImage {\n  background-color: #ffffff;\n  border-radius: 50%;\n  height: 63px;\n  width: 63px;\n  /* margin-right: 13px; */\n}\n\n.profile {\n  padding: 32px 15px;\n  display: flex; \n  gap: 10px;\n  /* text-align: left; */\n  cursor: pointer;\n  align-items: center;\n  justify-items: center;\n}\n\n.settings {\n  display: flex;\n  align-items: center;\n  color: #c1c5df;\n  cursor: pointer;\n}\n\n.logout {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 25px;\n  z-index: 80;\n  background-color: #656f84;\n  border-radius: 14px;\n  position: absolute;\n  white-space: nowrap;\n}\n\n.logoutTip {\n  height: 36px;\n  width: 36px;\n  position: absolute;\n  background-color: #656f84;\n  transform: rotateZ(45deg);\n  left: -11px;\n  border-radius: 6px;\n  z-index: 50;\n}\n\n.logoutContainer {\n  font-family: Poppins, sans-serif;\n  position: absolute;\n  z-index: 100;\n  border-radius: 14px;\n  max-height: 64px;\n  box-shadow: rgba(0, 0, 0, 25%) 0 5px 0 4px;\n  right: 0%;\n  top: 25%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `sidebar_container__nsVY6`,
	"logoContainer": `sidebar_logoContainer__7+w3t`,
	"sidebarDivider": `sidebar_sidebarDivider__Y+Kq2`,
	"sidebarItem": `sidebar_sidebarItem__Awi0D`,
	"sidebarItemSelected": `sidebar_sidebarItemSelected__+N2kx`,
	"sidebarItemPill": `sidebar_sidebarItemPill__1y8lT`,
	"sidebarBottom": `sidebar_sidebarBottom__3Gbom`,
	"profileImage": `sidebar_profileImage__6Tdv4`,
	"profile": `sidebar_profile__ccsPW`,
	"settings": `sidebar_settings__UAPW1`,
	"logout": `sidebar_logout__B27YB`,
	"logoutTip": `sidebar_logoutTip__uaojO`,
	"logoutContainer": `sidebar_logoutContainer__l6-lH`
};
export default ___CSS_LOADER_EXPORT___;
